import Alpine from 'alpinejs'
import whenDomReady from "when-dom-ready"
import ticketBookingForm from './TicketBooking/TicketBooking'

declare global {
    interface Window {
        Alpine: typeof Alpine
        algoliaAppId: string
        algoliaSearchOnlyApiKey: string
    }
}

function swipeCloseMenu() {
    let startX = 0

    document.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX
    })

    document.addEventListener('touchend', e => {
        const endX = e.changedTouches[0].clientX
        if (endX - startX > 50) { // swipe right
            const navStore = Alpine.store('nav_menu')
            if (navStore.shown) {
                navStore.toggle()
            }
        }
    })
}
whenDomReady(async () => {
    window.Alpine = Alpine
    window.algoliaAppId = import.meta.env.VITE_ALGOLIA_APP_ID as string
    window.algoliaSearchOnlyApiKey = import.meta.env.VITE_ALGOLIA_SEARCH_ONLY_API_KEY as string

    document.addEventListener('alpine:init', () => {
        ticketBookingForm()

        const navMenu = {
            shown: false,
            toggle() {
                this.shown = !this.shown
            }
        }
        Alpine.store('nav_menu', navMenu)
    })

    swipeCloseMenu()

    jQuery('#fluentform_1').on('fluentform_submission_success', function () {
        jQuery('.modal-scroll-box').removeClass('overflow-y-auto')
    })
    Alpine.start()

})

// Hot Module Logic
if ((import.meta as any).hot) {
    (import.meta as any).hot.on('vite:beforeFullReload', () => {
        throw '(skipping full reload)'
    })
}
